import Head from 'next/head'
import React from 'react'
import AdaptiveThemeBox from '../atoms/AdaptiveThemeBox'
import ThemeBox from '../atoms/ThemeBox'
import ThemedBackground from '../atoms/ThemedBackground'
import Container from '../molecules/Container'
import HeaderBar from '../organisms/HeaderBar'
import ParticleHeader from '../molecules/ParticleHeader'
import { attributes } from '../content/projects.md'
import { CasesPage } from '../content/types'
import { useLocale } from '../hooks/useLocale'
import Footer from '../organisms/Footer'
import MetaInformation from '../utils/MetaInformation'
import GridCasesLayout from '@/molecules/GridCasesLayout'
import CaseTile from '@/atoms/CaseTile'
import ContactUsCTA from '@/organisms/ContactCTA'

export default function Projects() {
  const { translations, locale } = useLocale<CasesPage>(attributes)

  return (
    <>
      <Head>
        <title>{translations.page_title}</title>
        <MetaInformation locale={locale} {...translations.meta} />
      </Head>
      <AdaptiveThemeBox defaultTheme="bright">
        <HeaderBar />
      </AdaptiveThemeBox>
      <ThemeBox theme="bright">
        <ThemedBackground>
          <Container>
            <ParticleHeader
              uptitle={translations.upper_title}
              title={translations.main_title}
            />
            <GridCasesLayout>
              {translations.cases.map((caseInfo, i) => (
                <CaseTile key={i} caseInfo={caseInfo} />
              ))}
            </GridCasesLayout>
            <ContactUsCTA />
          </Container>
        </ThemedBackground>
      </ThemeBox>
      <ThemeBox theme="black">
        <Footer />
      </ThemeBox>
    </>
  )
}
